<template>
  <div id="create-location" class="container">
    <div class="row">
      <div class="col-12">
        <notification
          id="create-location-error-msg"
          v-if="error"
          @close="resetError()"
          :message="error"
          type="alert-danger"
        ></notification>
        <location-form
          successTitle="Create"
          cancelTitle="Cancel"
          :create="true"
          :location.sync="location"
          :successAction="createLocation"
          :cancelAction="cancel"
        ></location-form>
      </div>
    </div>
  </div>
</template>

<script>
import CoreAPI from "@/utils/core-api";
import * as modals from "@/utils/modals";
import LocationForm from "./LocationForm";
import Notification from "@/components/Notification";

export default {
  name: "CreateLocation",
  components: {
    LocationForm,
    Notification
  },
  data() {
    return {
      loading: true,
      location: {},
      error: null
    };
  },
  methods: {
    cancel() {
      this.$router.push({ name: "Locations" });
    },
    resetError() {
      this.error = null;
    },
    async createLocation() {
      try {
        await CoreAPI.createLocation(this.location);
        this.$router.push({ name: "Locations" });
      } catch (error) {
        this.error = "Failed to save location";

        if (error.isNetworkError) {
          await modals.showLostConnectionModal(this.$bvModal);
        }
      }
    }
  }
};
</script>
